import React, { Component } from 'react';
import moreSuitable from '../img/more-suitable.png';
import lessSuitable from '../img/less-suitable.png';

class RankTableRow extends Component {    
    getRank(value){
        if (value === null)return 'invalid';
        if (value <= 3)return 'rank-1';
        if (value <= 6)return 'rank-2';
        if (value <= 10)return 'rank-3';
        if (value <= 15)return 'rank-4';
        if (value <= 21)return 'rank-5';
        if (value <= 33)return 'rank-6';
        if (value <= 46)return 'rank-7';
        if (value <= 61)return 'rank-8';
        if (value <= 75)return 'rank-9';
        return 'rank-10';
    }

    render() {
        if (!this.props.data)return null;        
        let data = this.props.data;
        return (            
            <div className="fund-row row">
                <div className={this.props.portrait ? "col-6 bg-gray" : "col-6 bg-gray replaceBeforeRender"}>{this.props.label}</div>
                <div className={"c1 " + this.getRank(data.Growth_R)}><span>{data.Growth_R}</span></div>
                <div className={"c1 " + this.getRank(data.Market_R)}><span>{data.Market_R}</span></div>
                <div className={"c1 " + this.getRank(data.Macro_R)}><span>{data.Macro_R}</span></div>
                <div className={"c1 " + this.getRank(data.Income_R)}><span>{data.Income_R}</span></div>
                <div className={"blended c1 bg-light "}><div><span>{this.props.data.rank.toFixed(0)}</span></div></div>
                { (this.props.activeKey === 0) ? <div className="c1"><img src={moreSuitable} height={25} alt="More Suitable" /></div> : null }
                { (this.props.activeKey === this.props.total) ? <div className="c1"><img src={lessSuitable} height={25} alt="Less Suitable" /></div> : null }
                { (this.props.activeKey !== 0 && this.props.activeKey !== this.props.total) ? <div className="c1"></div> : null }
            </div>
        );
    }
}

export default RankTableRow;